module.exports = __webpack_public_path__ + "img/cy1.24541adc.png";